module.exports = {
    type: 'none',
    text: '•'
};
